<template>
  <div>
    <div v-if="error">
      <p>{{ getErrorMessage(errorCode) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props : {
    error : {
      type: Boolean,
      required: true,
      default: false,
    },
    errorCode: {
      type: String,
      required: true,
      default: "",
    }
  }
}

</script>
